import * as React from "react";
import {
  Stack,
  Divider,
  IconButton,
  Typography,
  Menu,
  Container,
  Box,
  useTheme,
  styled,
  useMediaQuery,
} from "@mui/material";
import bfLogo from "../../assets/images/utsav-pack-logo.png";
import instagram from "../../assets/icons/basil_instagram-solid.png";
import youtube from "../../assets/icons/basil_youtube-solid.png";
import whatsapp from "../../assets/icons/mage_whatsapp-filled.png";
import facebook from "../../assets/icons/gg_facebook.png";
import playstore from "../../assets/icons/Store download button.png";
import appstore from "../../assets/icons/app Store download button.png";
// import botim from "../../assets/icons/botim.png";
import botim from "../../assets/icons/botim.png";

import { Link, NavLink } from "react-router";

const StyledLink = styled(NavLink)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0%",
  textDecoration: "none",
  color: "inherit",
  textAlign: "left",
  "&:hover": {
    color: "var(--primary-red-base)",
  },

  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    paddingLeft: "24px",
  },
}));

function Copyright() {
  return (
    <Typography
      sx={{
        color: "text.secondary",
        mt: 1,
        fontSize: "12px",
        fontFamily: "Montserrat",
        fontWeight: 600,
        lineHeight: "16px",
        letterSpacing: "0%",
      }}
    >
      {"Copyright © "}
      &nbsp;
      {new Date().getFullYear()} &nbsp;&nbsp; | &nbsp;&nbsp;All Rights Reserved
    </Typography>
  );
}
const SocialMediaIcon = () => {
  const handleBotimClick = () => {
    // ✅ CHANGED: Use 'chat' instead of 'call'
    const deepLink = "botim://chat?phone=+91XXXXXXXXXX";

    const appStoreLinks = {
      ios: "https://apps.apple.com/app/botim/id1033885865",
      android:
        "https://play.google.com/store/apps/details?id=im.thebot.messenger",
      web: "https://www.botim.me/",
    };

    // Try to open app
    window.location.href = deepLink;

    // Detect platform and fallback
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);

    setTimeout(() => {
      if (!document.hidden) {
        if (isIOS) {
          window.location.href = appStoreLinks.ios;
        } else if (isAndroid) {
          window.location.href = appStoreLinks.android;
        } else {
          window.open(appStoreLinks.web, "_blank");
        }
      }
    }, 1500);
  };
  return (
    <>
      <IconButton
        color="inherit"
        size="small"
        href="#"
        hidden
        aria-label="Instagram"
        sx={{ alignSelf: "center" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={instagram} alt="Instagram" width={24} height={24} />
      </IconButton>
      {/* <IconButton
                  color="inherit"
                  size="small"
                  href="https://x.com/MaterialUI"
                  aria-label="X"
                  sx={{ alignSelf: "center" }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={youtube} alt="" width={24} height={24} />
                </IconButton> */}
      <IconButton
        color="inherit"
        size="small"
        href="https://wa.me/918489811444"
        aria-label="Chat with Utsav Pack on WhatsApp"
        sx={{ alignSelf: "center" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={whatsapp} alt="WhatsApp" width={24} height={24} />
      </IconButton>
      <IconButton
        color="inherit"
        size="small"
        href="#"
        hidden
        aria-label="LinkedIn"
        sx={{ alignSelf: "center" }}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={facebook} alt="Facebook" width={24} height={24} />
      </IconButton>

      <IconButton
        color="inherit"
        size="small"
        onClick={handleBotimClick}
        aria-label="BOTIM"
        hidden
        sx={{ alignSelf: "center" }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
          }}
        >
          <img
            src={botim}
            alt="BOTIM"
            width={18}
            height={18}
            style={{ borderRadius: 4 }}
          />
        </Box>
      </IconButton>
    </>
  );
};

export default function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <React.Fragment>
      <Box
        sx={{
          height: "3px",
          background:
            "linear-gradient(90deg, transparent 0%, rgba(183,123,26,0.65) 20%, rgba(183,123,26,0.2) 50%, transparent 100%)",
        }}
      />
      <Container
        maxWidth="none"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: { xs: 4, sm: 6 },
          py: { xs: 4, sm: 7 },
          textAlign: { sm: "center", md: "left" },
          background: "linear-gradient(180deg, #fffdf9 0%, #fff 100%)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "100%",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: { xs: 3, md: 4 },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: { xs: "center", md: "flex-start" } }}>
            <Box component="img" alt="Utsav Pack" src={bfLogo} sx={{ maxWidth: "170px", width: "100%" }} />
            <Typography
              sx={{
                fontSize: "13px",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                fontWeight: 700,
                color: "var(--primary-red-base)",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Packaging • Printing • Possibilities
            </Typography>
            <Stack direction="row" spacing={1} sx={{ justifyContent: { xs: "center", md: "flex-start" } }}>
              <SocialMediaIcon />
            </Stack>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))" },
              gap: 1.5,
              width: { xs: "100%", md: "auto" },
              maxWidth: { xs: "100%", md: "520px" },
            }}
          >
            <StyledLink to="/account/profile">Accounts</StyledLink>
            <StyledLink to="/account/my-orders">Orders</StyledLink>
            <StyledLink to="/about-us">About Us</StyledLink>
            <StyledLink to="/contact-us">Contact Us</StyledLink>
            <StyledLink to="/refund-policy">Refund Policy</StyledLink>
            <StyledLink to="/terms-and-conditions">Terms</StyledLink>
          </Box>
        </Box>

        <Divider sx={{ borderColor: "rgba(183,123,26,0.14)", width: "100%" }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              color: "var(--neutral-600)",
              fontSize: "12px",
              fontWeight: 600,
              letterSpacing: "0.04em",
              textAlign: "center",
            }}
          >
            Copyright © {new Date().getFullYear()} • All Rights Reserved
          </Typography>
          <Typography
            sx={{
              color: "var(--neutral-500)",
              fontSize: "12px",
              fontWeight: 600,
              letterSpacing: "0.04em",
            }}
          >
            Thoughtful packaging, made simple.
          </Typography>
        </Box>
      </Container>
    </React.Fragment>
  );
}
const AnimatedDownloadWrapper = styled("div")(() => ({
  position: "relative",
  display: "inline-block",
  overflow: "hidden",
  borderRadius: "5px",

  "& span": {
    position: "absolute",
    display: "block",
  },

  "& span:nth-of-type(1)": {
    top: 0,
    left: "-100%",
    width: "100%",
    height: "2px",
    background: "linear-gradient(90deg, transparent, var(--primary-red-base))",
  },

  "& span:nth-of-type(2)": {
    top: "-100%",
    right: 0,
    width: "2px",
    height: "100%",
    background: "linear-gradient(180deg, transparent,var(--primary-red-base))",
  },

  "& span:nth-of-type(3)": {
    bottom: 0,
    right: "-100%",
    width: "100%",
    height: "2px",
    background: "linear-gradient(270deg, transparent, var(--primary-red-base))",
  },

  "& span:nth-of-type(4)": {
    bottom: "-100%",
    left: 0,
    width: "2px",
    height: "100%",
    background: "linear-gradient(360deg, transparent, var(--primary-red-base))",
  },

  "&:hover span:nth-of-type(1), &.animate span:nth-of-type(1)": {
    left: "100%",
    transition: "1s",
  },
  "&:hover span:nth-of-type(2), &.animate span:nth-of-type(2)": {
    top: "100%",
    transition: "1s",
    transitionDelay: "0.25s",
  },
  "&:hover span:nth-of-type(3), &.animate span:nth-of-type(3)": {
    right: "100%",
    transition: "1s",
    transitionDelay: "0.5s",
  },
  "&:hover span:nth-of-type(4), &.animate span:nth-of-type(4)": {
    bottom: "100%",
    transition: "1s",
    transitionDelay: "0.75s",
  },
}));
